import { Organisation } from '@percent/cause-dashboard/services/cause/causeService.types'
import { FlagAvatar } from '@percent/lemonade'
import { Alpha3Code } from 'i18n-iso-countries'
import styles from './OrganisationSignupCard.module.scss'

export const OrganisationSignupCard = ({ orgData }: { orgData: Organisation | null }) => {
  if (!orgData) {
    return (
      <div className={styles.organisationCard}>
        <div className={styles.loadingSkeleton}>
          <div className={styles.skeletonHeader}></div>
          <div className={styles.skeletonLine}></div>
          <div className={`${styles.skeletonLine} ${styles.short}`}></div>
          <div className={`${styles.skeletonLine} ${styles.medium}`}></div>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.organisationCard}>
      <div className={styles.organisationHeader}>
        <strong>{orgData.name}</strong>
        <FlagAvatar code3={orgData.countryCode as Alpha3Code} width="20px" />
      </div>
      <div className={styles.organisationDetail}>
        <a href={orgData.website ?? ''} className={styles.websiteLink}>
          {orgData?.website || ''}
        </a>
      </div>
      <div className={styles.organisationDetail}>Registry ID: {orgData.registryId}</div>
      <div className={styles.organisationDetail}>{orgData.address ?? ''}</div>
    </div>
  )
}
